import api from "./api";

const listarDiretorios = async () => {
    try {
        const response = await api.get("/diretorios");
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const listarDiretoriosPorIDPai = async (IDDiretorioPai, IDProcesso, filtros = {}) => {
    try {
        const response = await api.get(`/diretorioByIDPai/${IDDiretorioPai}/${IDProcesso}`, {
            params: filtros,
        });
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const atualizarSituacaoDiretorio = async (IDDiretorio, situacao) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/situacao`, { situacao });
        return response;
    } catch (error) {
        console.error('Falha ao atualizar situação do diretório', error);
        throw error;
    }
};

const renomearDiretorio = async (IDDiretorio, nome) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/renomear`, { descricaoExibicao: nome });
        return response;
    } catch (error) {
        console.error('Falha ao renomear o diretório', error);
        throw error;
    }
};

const buscarProtecaoDiretorio = async (IDDiretorio) => {
    try {
        const response = await api.get(`/diretorio/${IDDiretorio}/protecao`);
        return response.data;
    } catch (error) {
        console.error('Falha ao buscar protecao do diretorio', error);
        throw error;
    }
};

const salvarProtecaoDiretorio = async (IDDiretorio, protegida, cargos) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/protecao`, {
            protegida,
            cargos,
        });
        return response;
    } catch (error) {
        console.error('Falha ao salvar protecao do diretorio', error);
        throw error;
    }
};

export const diretorioService = {
    listarDiretorios,
    listarDiretoriosPorIDPai,
    atualizarSituacaoDiretorio,
    renomearDiretorio,
    buscarProtecaoDiretorio,
    salvarProtecaoDiretorio
};
